import { render, staticRenderFns } from "./eliminarCuenta.vue?vue&type=template&id=7ea2eb28&scoped=true"
import script from "./eliminarCuenta.vue?vue&type=script&lang=js"
export * from "./eliminarCuenta.vue?vue&type=script&lang=js"
import style0 from "./eliminarCuenta.vue?vue&type=style&index=0&id=7ea2eb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea2eb28",
  null
  
)

export default component.exports